module.exports = __webpack_public_path__ + "img/sprite_3.f3d8b20b.png";